"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _acerno = _interopRequireDefault(require("./14_group_2022_10_11/acerno"));

var _acquappesa = _interopRequireDefault(require("./14_group_2022_10_11/acquappesa"));

var _acuto = _interopRequireDefault(require("./14_group_2022_10_11/acuto"));

var _agnone = _interopRequireDefault(require("./14_group_2022_10_11/agnone"));

var _aicurzio = _interopRequireDefault(require("./14_group_2022_10_11/aicurzio"));

var _aielli = _interopRequireDefault(require("./14_group_2022_10_11/aielli"));

var _alanno = _interopRequireDefault(require("./14_group_2022_10_11/alanno"));

var _albi = _interopRequireDefault(require("./14_group_2022_10_11/albi"));

var _albosaggia = _interopRequireDefault(require("./14_group_2022_10_11/albosaggia"));

var _alzanoLombardo = _interopRequireDefault(require("./14_group_2022_10_11/alzano-lombardo"));

var _apice = _interopRequireDefault(require("./14_group_2022_10_11/apice"));

var _arienzo = _interopRequireDefault(require("./14_group_2022_10_11/arienzo"));

var _armo = _interopRequireDefault(require("./14_group_2022_10_11/armo"));

var _arpaise = _interopRequireDefault(require("./14_group_2022_10_11/arpaise"));

var _arrone = _interopRequireDefault(require("./14_group_2022_10_11/arrone"));

var _avellino = _interopRequireDefault(require("./14_group_2022_10_11/avellino"));

var _badiaTedalda = _interopRequireDefault(require("./14_group_2022_10_11/badia-tedalda"));

var _barisciano = _interopRequireDefault(require("./14_group_2022_10_11/barisciano"));

var _belmonteInSabina = _interopRequireDefault(require("./14_group_2022_10_11/belmonte-in-sabina"));

var _belvedereDiSpinello = _interopRequireDefault(require("./14_group_2022_10_11/belvedere-di-spinello"));

var _bisacquino = _interopRequireDefault(require("./14_group_2022_10_11/bisacquino"));

var _blufi = _interopRequireDefault(require("./14_group_2022_10_11/blufi"));

var _bonorva = _interopRequireDefault(require("./14_group_2022_10_11/bonorva"));

var _borghettoDArroscia = _interopRequireDefault(require("./14_group_2022_10_11/borghetto-d-arroscia"));

var _borghettoDiBorbera = _interopRequireDefault(require("./14_group_2022_10_11/borghetto-di-borbera"));

var _borghettoDiVara = _interopRequireDefault(require("./14_group_2022_10_11/borghetto-di-vara"));

var _boscoreale = _interopRequireDefault(require("./14_group_2022_10_11/boscoreale"));

var _bracca = _interopRequireDefault(require("./14_group_2022_10_11/bracca"));

var _bregnano = _interopRequireDefault(require("./14_group_2022_10_11/bregnano"));

var _brusciano = _interopRequireDefault(require("./14_group_2022_10_11/brusciano"));

var _buccino = _interopRequireDefault(require("./14_group_2022_10_11/buccino"));

var _buglioInMonte = _interopRequireDefault(require("./14_group_2022_10_11/buglio-in-monte"));

var _buonabitacolo = _interopRequireDefault(require("./14_group_2022_10_11/buonabitacolo"));

var _cagliari = _interopRequireDefault(require("./14_group_2022_10_11/cagliari"));

var _cagnanoAmiterno = _interopRequireDefault(require("./14_group_2022_10_11/cagnano-amiterno"));

var _cagnanoVarano = _interopRequireDefault(require("./14_group_2022_10_11/cagnano-varano"));

var _caianello = _interopRequireDefault(require("./14_group_2022_10_11/caianello"));

var _calestano = _interopRequireDefault(require("./14_group_2022_10_11/calestano"));

var _caliceAlCornoviglio = _interopRequireDefault(require("./14_group_2022_10_11/calice-al-cornoviglio"));

var _calvanico = _interopRequireDefault(require("./14_group_2022_10_11/calvanico"));

var _camerataCornello = _interopRequireDefault(require("./14_group_2022_10_11/camerata-cornello"));

var _campoliDelMonteTaburno = _interopRequireDefault(require("./14_group_2022_10_11/campoli-del-monte-taburno"));

var _camposano = _interopRequireDefault(require("./14_group_2022_10_11/camposano"));

var _canalSanBovo = _interopRequireDefault(require("./14_group_2022_10_11/canal-san-bovo"));

var _candelo = _interopRequireDefault(require("./14_group_2022_10_11/candelo"));

var _cantalupoInSabina = _interopRequireDefault(require("./14_group_2022_10_11/cantalupo-in-sabina"));

var _capodrise = _interopRequireDefault(require("./14_group_2022_10_11/capodrise"));

var _caravate = _interopRequireDefault(require("./14_group_2022_10_11/caravate"));

var _careggine = _interopRequireDefault(require("./14_group_2022_10_11/careggine"));

var _carinaro = _interopRequireDefault(require("./14_group_2022_10_11/carinaro"));

var _casagiove = _interopRequireDefault(require("./14_group_2022_10_11/casagiove"));

var _casalCermelli = _interopRequireDefault(require("./14_group_2022_10_11/casal-cermelli"));

var _casalnoceto = _interopRequireDefault(require("./14_group_2022_10_11/casalnoceto"));

var _casanovaLerrone = _interopRequireDefault(require("./14_group_2022_10_11/casanova-lerrone"));

var _casaprota = _interopRequireDefault(require("./14_group_2022_10_11/casaprota"));

var _cassanoSpinola = _interopRequireDefault(require("./14_group_2022_10_11/cassano-spinola"));

var _cassanoValcuvia = _interopRequireDefault(require("./14_group_2022_10_11/cassano-valcuvia"));

var _castelFocognano = _interopRequireDefault(require("./14_group_2022_10_11/castel-focognano"));

var _castelSantAngelo = _interopRequireDefault(require("./14_group_2022_10_11/castel-sant-angelo"));

var _castelViscardo = _interopRequireDefault(require("./14_group_2022_10_11/castel-viscardo"));

var _castelnuovoParano = _interopRequireDefault(require("./14_group_2022_10_11/castelnuovo-parano"));

var _castroLe = _interopRequireDefault(require("./14_group_2022_10_11/castro-le"));

var _castronno = _interopRequireDefault(require("./14_group_2022_10_11/castronno"));

var _castroreale = _interopRequireDefault(require("./14_group_2022_10_11/castroreale"));

var _cavargna = _interopRequireDefault(require("./14_group_2022_10_11/cavargna"));

var _cavernago = _interopRequireDefault(require("./14_group_2022_10_11/cavernago"));

var _cellara = _interopRequireDefault(require("./14_group_2022_10_11/cellara"));

var _cenadi = _interopRequireDefault(require("./14_group_2022_10_11/cenadi"));

var _centroValleIntelvi = _interopRequireDefault(require("./14_group_2022_10_11/centro-valle-intelvi"));

var _centuripe = _interopRequireDefault(require("./14_group_2022_10_11/centuripe"));

var _cercivento = _interopRequireDefault(require("./14_group_2022_10_11/cercivento"));

var _cerroAlLambro = _interopRequireDefault(require("./14_group_2022_10_11/cerro-al-lambro"));

var _chiuro = _interopRequireDefault(require("./14_group_2022_10_11/chiuro"));

var _chiusavecchia = _interopRequireDefault(require("./14_group_2022_10_11/chiusavecchia"));

var _cicciano = _interopRequireDefault(require("./14_group_2022_10_11/cicciano"));

var _cisanoBergamasco = _interopRequireDefault(require("./14_group_2022_10_11/cisano-bergamasco"));

var _cislago = _interopRequireDefault(require("./14_group_2022_10_11/cislago"));

var _cittareale = _interopRequireDefault(require("./14_group_2022_10_11/cittareale"));

var _cittiglio = _interopRequireDefault(require("./14_group_2022_10_11/cittiglio"));

var _civitaquana = _interopRequireDefault(require("./14_group_2022_10_11/civitaquana"));

var _clivio = _interopRequireDefault(require("./14_group_2022_10_11/clivio"));

var _comabbio = _interopRequireDefault(require("./14_group_2022_10_11/comabbio"));

var _cortazzone = _interopRequireDefault(require("./14_group_2022_10_11/cortazzone"));

var _cosseria = _interopRequireDefault(require("./14_group_2022_10_11/cosseria"));

var _cremella = _interopRequireDefault(require("./14_group_2022_10_11/cremella"));

var _crevoladossola = _interopRequireDefault(require("./14_group_2022_10_11/crevoladossola"));

var _cuvio = _interopRequireDefault(require("./14_group_2022_10_11/cuvio"));

var _dego = _interopRequireDefault(require("./14_group_2022_10_11/dego"));

var _dolcedo = _interopRequireDefault(require("./14_group_2022_10_11/dolcedo"));

var _drenchia = _interopRequireDefault(require("./14_group_2022_10_11/drenchia"));

var _duinoAurisina = _interopRequireDefault(require("./14_group_2022_10_11/duino-aurisina"));

var _erula = _interopRequireDefault(require("./14_group_2022_10_11/erula"));

var _faedoValtellino = _interopRequireDefault(require("./14_group_2022_10_11/faedo-valtellino"));

var _faloppio = _interopRequireDefault(require("./14_group_2022_10_11/faloppio"));

var _fanna = _interopRequireDefault(require("./14_group_2022_10_11/fanna"));

var _farindola = _interopRequireDefault(require("./14_group_2022_10_11/farindola"));

var _filago = _interopRequireDefault(require("./14_group_2022_10_11/filago"));

var _firmo = _interopRequireDefault(require("./14_group_2022_10_11/firmo"));

var _foglianise = _interopRequireDefault(require("./14_group_2022_10_11/foglianise"));

var _fontanaLiri = _interopRequireDefault(require("./14_group_2022_10_11/fontana-liri"));

var _forano = _interopRequireDefault(require("./14_group_2022_10_11/forano"));

var _galloMatese = _interopRequireDefault(require("./14_group_2022_10_11/gallo-matese"));

var _gasperina = _interopRequireDefault(require("./14_group_2022_10_11/gasperina"));

var _germignaga = _interopRequireDefault(require("./14_group_2022_10_11/germignaga"));

var _gianoVetusto = _interopRequireDefault(require("./14_group_2022_10_11/giano-vetusto"));

var _gorizia = _interopRequireDefault(require("./14_group_2022_10_11/gorizia"));

var _gromo = _interopRequireDefault(require("./14_group_2022_10_11/gromo"));

var _grotteDiCastro = _interopRequireDefault(require("./14_group_2022_10_11/grotte-di-castro"));

var _guarcino = _interopRequireDefault(require("./14_group_2022_10_11/guarcino"));

var _guardiaSanframondi = _interopRequireDefault(require("./14_group_2022_10_11/guardia-sanframondi"));

var _imbersago = _interopRequireDefault(require("./14_group_2022_10_11/imbersago"));

var _isolaDelGranSassoDItalia = _interopRequireDefault(require("./14_group_2022_10_11/isola-del-gran-sasso-d-italia"));

var _itala = _interopRequireDefault(require("./14_group_2022_10_11/itala"));

var _lanzoTorinese = _interopRequireDefault(require("./14_group_2022_10_11/lanzo-torinese"));

var _lapio = _interopRequireDefault(require("./14_group_2022_10_11/lapio"));

var _lavello = _interopRequireDefault(require("./14_group_2022_10_11/lavello"));

var _lecco = _interopRequireDefault(require("./14_group_2022_10_11/lecco"));

var _lonateCeppino = _interopRequireDefault(require("./14_group_2022_10_11/lonate-ceppino"));

var _lovero = _interopRequireDefault(require("./14_group_2022_10_11/lovero"));

var _luogosanto = _interopRequireDefault(require("./14_group_2022_10_11/luogosanto"));

var _magliolo = _interopRequireDefault(require("./14_group_2022_10_11/magliolo"));

var _mallare = _interopRequireDefault(require("./14_group_2022_10_11/mallare"));

var _manziana = _interopRequireDefault(require("./14_group_2022_10_11/manziana"));

var _marcalloConCasone = _interopRequireDefault(require("./14_group_2022_10_11/marcallo-con-casone"));

var _marcellina = _interopRequireDefault(require("./14_group_2022_10_11/marcellina"));

var _marcellinara = _interopRequireDefault(require("./14_group_2022_10_11/marcellinara"));

var _meduno = _interopRequireDefault(require("./14_group_2022_10_11/meduno"));

var _mezzago = _interopRequireDefault(require("./14_group_2022_10_11/mezzago"));

var _moliniDiTriora = _interopRequireDefault(require("./14_group_2022_10_11/molini-di-triora"));

var _mombercelli = _interopRequireDefault(require("./14_group_2022_10_11/mombercelli"));

var _moncestino = _interopRequireDefault(require("./14_group_2022_10_11/moncestino"));

var _monchioDelleCorti = _interopRequireDefault(require("./14_group_2022_10_11/monchio-delle-corti"));

var _moncuccoTorinese = _interopRequireDefault(require("./14_group_2022_10_11/moncucco-torinese"));

var _mongiuffiMelia = _interopRequireDefault(require("./14_group_2022_10_11/mongiuffi-melia"));

var _montabone = _interopRequireDefault(require("./14_group_2022_10_11/montabone"));

var _montaldoScarampi = _interopRequireDefault(require("./14_group_2022_10_11/montaldo-scarampi"));

var _montaltoCarpasio = _interopRequireDefault(require("./14_group_2022_10_11/montalto-carpasio"));

var _montechiaroDAcqui = _interopRequireDefault(require("./14_group_2022_10_11/montechiaro-d-acqui"));

var _montegiordano = _interopRequireDefault(require("./14_group_2022_10_11/montegiordano"));

var _montella = _interopRequireDefault(require("./14_group_2022_10_11/montella"));

var _montenerodomo = _interopRequireDefault(require("./14_group_2022_10_11/montenerodomo"));

var _monticelliDOngina = _interopRequireDefault(require("./14_group_2022_10_11/monticelli-d-ongina"));

var _morbegno = _interopRequireDefault(require("./14_group_2022_10_11/morbegno"));

var _mozzagrogna = _interopRequireDefault(require("./14_group_2022_10_11/mozzagrogna"));

var _murialdo = _interopRequireDefault(require("./14_group_2022_10_11/murialdo"));

var _nasino = _interopRequireDefault(require("./14_group_2022_10_11/nasino"));

var _nociglia = _interopRequireDefault(require("./14_group_2022_10_11/nociglia"));

var _novara = _interopRequireDefault(require("./14_group_2022_10_11/novara"));

var _noviVelia = _interopRequireDefault(require("./14_group_2022_10_11/novi-velia"));

var _occhieppoSuperiore = _interopRequireDefault(require("./14_group_2022_10_11/occhieppo-superiore"));

var _orsaraBormida = _interopRequireDefault(require("./14_group_2022_10_11/orsara-bormida"));

var _ortaDiAtella = _interopRequireDefault(require("./14_group_2022_10_11/orta-di-atella"));

var _ottana = _interopRequireDefault(require("./14_group_2022_10_11/ottana"));

var _palizzi = _interopRequireDefault(require("./14_group_2022_10_11/palizzi"));

var _parre = _interopRequireDefault(require("./14_group_2022_10_11/parre"));

var _paulilatino = _interopRequireDefault(require("./14_group_2022_10_11/paulilatino"));

var _paullo = _interopRequireDefault(require("./14_group_2022_10_11/paullo"));

var _petrellaSalto = _interopRequireDefault(require("./14_group_2022_10_11/petrella-salto"));

var _pettinengo = _interopRequireDefault(require("./14_group_2022_10_11/pettinengo"));

var _piedimonteMatese = _interopRequireDefault(require("./14_group_2022_10_11/piedimonte-matese"));

var _pietralunga = _interopRequireDefault(require("./14_group_2022_10_11/pietralunga"));

var _pieveDiBonoPrezzo = _interopRequireDefault(require("./14_group_2022_10_11/pieve-di-bono-prezzo"));

var _pignataroMaggiore = _interopRequireDefault(require("./14_group_2022_10_11/pignataro-maggiore"));

var _pignone = _interopRequireDefault(require("./14_group_2022_10_11/pignone"));

var _piovaMassaia = _interopRequireDefault(require("./14_group_2022_10_11/piova-massaia"));

var _plesio = _interopRequireDefault(require("./14_group_2022_10_11/plesio"));

var _pollone = _interopRequireDefault(require("./14_group_2022_10_11/pollone"));

var _pontedassio = _interopRequireDefault(require("./14_group_2022_10_11/pontedassio"));

var _pontelatone = _interopRequireDefault(require("./14_group_2022_10_11/pontelatone"));

var _postiglione = _interopRequireDefault(require("./14_group_2022_10_11/postiglione"));

var _praiano = _interopRequireDefault(require("./14_group_2022_10_11/praiano"));

var _prato = _interopRequireDefault(require("./14_group_2022_10_11/prato"));

var _pratolaPeligna = _interopRequireDefault(require("./14_group_2022_10_11/pratola-peligna"));

var _pregnanaMilanese = _interopRequireDefault(require("./14_group_2022_10_11/pregnana-milanese"));

var _primieroSanMartinoDiCastrozza = _interopRequireDefault(require("./14_group_2022_10_11/primiero-san-martino-di-castrozza"));

var _prizzi = _interopRequireDefault(require("./14_group_2022_10_11/prizzi"));

var _pumenengo = _interopRequireDefault(require("./14_group_2022_10_11/pumenengo"));

var _riparbella = _interopRequireDefault(require("./14_group_2022_10_11/riparbella"));

var _riveDArcano = _interopRequireDefault(require("./14_group_2022_10_11/rive-d-arcano"));

var _robella = _interopRequireDefault(require("./14_group_2022_10_11/robella"));

var _roccaSanFelice = _interopRequireDefault(require("./14_group_2022_10_11/rocca-san-felice"));

var _roccaSantaMaria = _interopRequireDefault(require("./14_group_2022_10_11/rocca-santa-maria"));

var _roccabernarda = _interopRequireDefault(require("./14_group_2022_10_11/roccabernarda"));

var _rovegno = _interopRequireDefault(require("./14_group_2022_10_11/rovegno"));

var _ruffano = _interopRequireDefault(require("./14_group_2022_10_11/ruffano"));

var _sanCiprianoDAversa = _interopRequireDefault(require("./14_group_2022_10_11/san-cipriano-d-aversa"));

var _sanCiprianoPicentino = _interopRequireDefault(require("./14_group_2022_10_11/san-cipriano-picentino"));

var _sanDonatoValDiComino = _interopRequireDefault(require("./14_group_2022_10_11/san-donato-val-di-comino"));

var _sanGiorgioMonferrato = _interopRequireDefault(require("./14_group_2022_10_11/san-giorgio-monferrato"));

var _sanGiovanniIncarico = _interopRequireDefault(require("./14_group_2022_10_11/san-giovanni-incarico"));

var _sanNazzaroValCavargna = _interopRequireDefault(require("./14_group_2022_10_11/san-nazzaro-val-cavargna"));

var _sanPietroAMaida = _interopRequireDefault(require("./14_group_2022_10_11/san-pietro-a-maida"));

var _sanPietroInGuarano = _interopRequireDefault(require("./14_group_2022_10_11/san-pietro-in-guarano"));

var _sanPrisco = _interopRequireDefault(require("./14_group_2022_10_11/san-prisco"));

var _sanTammaro = _interopRequireDefault(require("./14_group_2022_10_11/san-tammaro"));

var _sanValentinoTorio = _interopRequireDefault(require("./14_group_2022_10_11/san-valentino-torio"));

var _santAnatoliaDiNarco = _interopRequireDefault(require("./14_group_2022_10_11/sant-anatolia-di-narco"));

var _santAngeloDAlife = _interopRequireDefault(require("./14_group_2022_10_11/sant-angelo-d-alife"));

var _santaMariaImbaro = _interopRequireDefault(require("./14_group_2022_10_11/santa-maria-imbaro"));

var _santeMarie = _interopRequireDefault(require("./14_group_2022_10_11/sante-marie"));

var _sarezzano = _interopRequireDefault(require("./14_group_2022_10_11/sarezzano"));

var _sarteano = _interopRequireDefault(require("./14_group_2022_10_11/sarteano"));

var _sassano = _interopRequireDefault(require("./14_group_2022_10_11/sassano"));

var _scigliano = _interopRequireDefault(require("./14_group_2022_10_11/scigliano"));

var _serradifalco = _interopRequireDefault(require("./14_group_2022_10_11/serradifalco"));

var _serraraFontana = _interopRequireDefault(require("./14_group_2022_10_11/serrara-fontana"));

var _sigillo = _interopRequireDefault(require("./14_group_2022_10_11/sigillo"));

var _sinopoli = _interopRequireDefault(require("./14_group_2022_10_11/sinopoli"));

var _sirtori = _interopRequireDefault(require("./14_group_2022_10_11/sirtori"));

var _solero = _interopRequireDefault(require("./14_group_2022_10_11/solero"));

var _soveriaMannelli = _interopRequireDefault(require("./14_group_2022_10_11/soveria-mannelli"));

var _sovramonte = _interopRequireDefault(require("./14_group_2022_10_11/sovramonte"));

var _specchia = _interopRequireDefault(require("./14_group_2022_10_11/specchia"));

var _stellaCilento = _interopRequireDefault(require("./14_group_2022_10_11/stella-cilento"));

var _succivo = _interopRequireDefault(require("./14_group_2022_10_11/succivo"));

var _sulbiate = _interopRequireDefault(require("./14_group_2022_10_11/sulbiate"));

var _taglioloMonferrato = _interopRequireDefault(require("./14_group_2022_10_11/tagliolo-monferrato"));

var _tizzanoValParma = _interopRequireDefault(require("./14_group_2022_10_11/tizzano-val-parma"));

var _toranoCastello = _interopRequireDefault(require("./14_group_2022_10_11/torano-castello"));

var _torchiarolo = _interopRequireDefault(require("./14_group_2022_10_11/torchiarolo"));

var _tornimparte = _interopRequireDefault(require("./14_group_2022_10_11/tornimparte"));

var _torreLeNocelle = _interopRequireDefault(require("./14_group_2022_10_11/torre-le-nocelle"));

var _tortora = _interopRequireDefault(require("./14_group_2022_10_11/tortora"));

var _trapani = _interopRequireDefault(require("./14_group_2022_10_11/trapani"));

var _udine = _interopRequireDefault(require("./14_group_2022_10_11/udine"));

var _valbrevenna = _interopRequireDefault(require("./14_group_2022_10_11/valbrevenna"));

var _valentano = _interopRequireDefault(require("./14_group_2022_10_11/valentano"));

var _valfenera = _interopRequireDefault(require("./14_group_2022_10_11/valfenera"));

var _valgreghentino = _interopRequireDefault(require("./14_group_2022_10_11/valgreghentino"));

var _vallecorsa = _interopRequireDefault(require("./14_group_2022_10_11/vallecorsa"));

var _vallioTerme = _interopRequireDefault(require("./14_group_2022_10_11/vallio-terme"));

var _valloDiNera = _interopRequireDefault(require("./14_group_2022_10_11/vallo-di-nera"));

var _vanzago = _interopRequireDefault(require("./14_group_2022_10_11/vanzago"));

var _vercurago = _interopRequireDefault(require("./14_group_2022_10_11/vercurago"));

var _vicovaro = _interopRequireDefault(require("./14_group_2022_10_11/vicovaro"));

var _vigevano = _interopRequireDefault(require("./14_group_2022_10_11/vigevano"));

var _villadeati = _interopRequireDefault(require("./14_group_2022_10_11/villadeati"));

var _villamassargia = _interopRequireDefault(require("./14_group_2022_10_11/villamassargia"));

var _vitoDAsio = _interopRequireDefault(require("./14_group_2022_10_11/vito-d-asio"));

var _vobarno = _interopRequireDefault(require("./14_group_2022_10_11/vobarno"));

var _vobbia = _interopRequireDefault(require("./14_group_2022_10_11/vobbia"));

var _zoagli = _interopRequireDefault(require("./14_group_2022_10_11/zoagli"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _acerno["default"], {}, _acquappesa["default"], {}, _acuto["default"], {}, _agnone["default"], {}, _aicurzio["default"], {}, _aielli["default"], {}, _alanno["default"], {}, _albi["default"], {}, _albosaggia["default"], {}, _alzanoLombardo["default"], {}, _apice["default"], {}, _arienzo["default"], {}, _armo["default"], {}, _arpaise["default"], {}, _arrone["default"], {}, _avellino["default"], {}, _badiaTedalda["default"], {}, _barisciano["default"], {}, _belmonteInSabina["default"], {}, _belvedereDiSpinello["default"], {}, _bisacquino["default"], {}, _blufi["default"], {}, _bonorva["default"], {}, _borghettoDArroscia["default"], {}, _borghettoDiBorbera["default"], {}, _borghettoDiVara["default"], {}, _boscoreale["default"], {}, _bracca["default"], {}, _bregnano["default"], {}, _brusciano["default"], {}, _buccino["default"], {}, _buglioInMonte["default"], {}, _buonabitacolo["default"], {}, _cagliari["default"], {}, _cagnanoAmiterno["default"], {}, _cagnanoVarano["default"], {}, _caianello["default"], {}, _calestano["default"], {}, _caliceAlCornoviglio["default"], {}, _calvanico["default"], {}, _camerataCornello["default"], {}, _campoliDelMonteTaburno["default"], {}, _camposano["default"], {}, _canalSanBovo["default"], {}, _candelo["default"], {}, _cantalupoInSabina["default"], {}, _capodrise["default"], {}, _caravate["default"], {}, _careggine["default"], {}, _carinaro["default"], {}, _casagiove["default"], {}, _casalCermelli["default"], {}, _casalnoceto["default"], {}, _casanovaLerrone["default"], {}, _casaprota["default"], {}, _cassanoSpinola["default"], {}, _cassanoValcuvia["default"], {}, _castelFocognano["default"], {}, _castelSantAngelo["default"], {}, _castelViscardo["default"], {}, _castelnuovoParano["default"], {}, _castroLe["default"], {}, _castronno["default"], {}, _castroreale["default"], {}, _cavargna["default"], {}, _cavernago["default"], {}, _cellara["default"], {}, _cenadi["default"], {}, _centroValleIntelvi["default"], {}, _centuripe["default"], {}, _cercivento["default"], {}, _cerroAlLambro["default"], {}, _chiuro["default"], {}, _chiusavecchia["default"], {}, _cicciano["default"], {}, _cisanoBergamasco["default"], {}, _cislago["default"], {}, _cittareale["default"], {}, _cittiglio["default"], {}, _civitaquana["default"], {}, _clivio["default"], {}, _comabbio["default"], {}, _cortazzone["default"], {}, _cosseria["default"], {}, _cremella["default"], {}, _crevoladossola["default"], {}, _cuvio["default"], {}, _dego["default"], {}, _dolcedo["default"], {}, _drenchia["default"], {}, _duinoAurisina["default"], {}, _erula["default"], {}, _faedoValtellino["default"], {}, _faloppio["default"], {}, _fanna["default"], {}, _farindola["default"], {}, _filago["default"], {}, _firmo["default"], {}, _foglianise["default"], {}, _fontanaLiri["default"], {}, _forano["default"], {}, _galloMatese["default"], {}, _gasperina["default"], {}, _germignaga["default"], {}, _gianoVetusto["default"], {}, _gorizia["default"], {}, _gromo["default"], {}, _grotteDiCastro["default"], {}, _guarcino["default"], {}, _guardiaSanframondi["default"], {}, _imbersago["default"], {}, _isolaDelGranSassoDItalia["default"], {}, _itala["default"], {}, _lanzoTorinese["default"], {}, _lapio["default"], {}, _lavello["default"], {}, _lecco["default"], {}, _lonateCeppino["default"], {}, _lovero["default"], {}, _luogosanto["default"], {}, _magliolo["default"], {}, _mallare["default"], {}, _manziana["default"], {}, _marcalloConCasone["default"], {}, _marcellina["default"], {}, _marcellinara["default"], {}, _meduno["default"], {}, _mezzago["default"], {}, _moliniDiTriora["default"], {}, _mombercelli["default"], {}, _moncestino["default"], {}, _monchioDelleCorti["default"], {}, _moncuccoTorinese["default"], {}, _mongiuffiMelia["default"], {}, _montabone["default"], {}, _montaldoScarampi["default"], {}, _montaltoCarpasio["default"], {}, _montechiaroDAcqui["default"], {}, _montegiordano["default"], {}, _montella["default"], {}, _montenerodomo["default"], {}, _monticelliDOngina["default"], {}, _morbegno["default"], {}, _mozzagrogna["default"], {}, _murialdo["default"], {}, _nasino["default"], {}, _nociglia["default"], {}, _novara["default"], {}, _noviVelia["default"], {}, _occhieppoSuperiore["default"], {}, _orsaraBormida["default"], {}, _ortaDiAtella["default"], {}, _ottana["default"], {}, _palizzi["default"], {}, _parre["default"], {}, _paulilatino["default"], {}, _paullo["default"], {}, _petrellaSalto["default"], {}, _pettinengo["default"], {}, _piedimonteMatese["default"], {}, _pietralunga["default"], {}, _pieveDiBonoPrezzo["default"], {}, _pignataroMaggiore["default"], {}, _pignone["default"], {}, _piovaMassaia["default"], {}, _plesio["default"], {}, _pollone["default"], {}, _pontedassio["default"], {}, _pontelatone["default"], {}, _postiglione["default"], {}, _praiano["default"], {}, _prato["default"], {}, _pratolaPeligna["default"], {}, _pregnanaMilanese["default"], {}, _primieroSanMartinoDiCastrozza["default"], {}, _prizzi["default"], {}, _pumenengo["default"], {}, _riparbella["default"], {}, _riveDArcano["default"], {}, _robella["default"], {}, _roccaSanFelice["default"], {}, _roccaSantaMaria["default"], {}, _roccabernarda["default"], {}, _rovegno["default"], {}, _ruffano["default"], {}, _sanCiprianoDAversa["default"], {}, _sanCiprianoPicentino["default"], {}, _sanDonatoValDiComino["default"], {}, _sanGiorgioMonferrato["default"], {}, _sanGiovanniIncarico["default"], {}, _sanNazzaroValCavargna["default"], {}, _sanPietroAMaida["default"], {}, _sanPietroInGuarano["default"], {}, _sanPrisco["default"], {}, _sanTammaro["default"], {}, _sanValentinoTorio["default"], {}, _santAnatoliaDiNarco["default"], {}, _santAngeloDAlife["default"], {}, _santaMariaImbaro["default"], {}, _santeMarie["default"], {}, _sarezzano["default"], {}, _sarteano["default"], {}, _sassano["default"], {}, _scigliano["default"], {}, _serradifalco["default"], {}, _serraraFontana["default"], {}, _sigillo["default"], {}, _sinopoli["default"], {}, _sirtori["default"], {}, _solero["default"], {}, _soveriaMannelli["default"], {}, _sovramonte["default"], {}, _specchia["default"], {}, _stellaCilento["default"], {}, _succivo["default"], {}, _sulbiate["default"], {}, _taglioloMonferrato["default"], {}, _tizzanoValParma["default"], {}, _toranoCastello["default"], {}, _torchiarolo["default"], {}, _tornimparte["default"], {}, _torreLeNocelle["default"], {}, _tortora["default"], {}, _trapani["default"], {}, _udine["default"], {}, _valbrevenna["default"], {}, _valentano["default"], {}, _valfenera["default"], {}, _valgreghentino["default"], {}, _vallecorsa["default"], {}, _vallioTerme["default"], {}, _valloDiNera["default"], {}, _vanzago["default"], {}, _vercurago["default"], {}, _vicovaro["default"], {}, _vigevano["default"], {}, _villadeati["default"], {}, _villamassargia["default"], {}, _vitoDAsio["default"], {}, _vobarno["default"], {}, _vobbia["default"], {}, _zoagli["default"]);

exports["default"] = _default;